import { useMutation } from '@occc-app/dataAccessLayer/utils';
import { snackbar } from '@occc-app/design-system';
import { useUpdateTriggeredMessageStatusMutation } from '@occc/graphql';

import { STATUS_UPDATE_ERROR_MESSAGE } from '../triggered-messages.constants';

export const useUpdateTriggeredMessageStatus = () => {
  const onError = () => {
    snackbar.error(STATUS_UPDATE_ERROR_MESSAGE);
  };

  return useMutation(useUpdateTriggeredMessageStatusMutation, {
    onError,
  });
};
